import {useMutation} from '@tanstack/react-query';
import {useCustomerMyFavorites} from 'api/queries';
import {customerAddToFavorites, customerRemoveFromFavorites} from 'api/requests';
import {useAuth} from 'hooks';
import GTMService from 'services/ga4';
import {ICustomerAddToFavoritesRequest} from 'types';

import {useToast} from './useToast';
import {useTranslation} from './useTranslation';

export const useEditFavorites = () => {
  const {isAuthenticated} = useAuth();

  const {data: myFavorite = [], isLoading, refetch} = useCustomerMyFavorites({enabled: isAuthenticated});

  const toast = useToast();
  const {t} = useTranslation();

  const addFavorite = useMutation<any, any, ICustomerAddToFavoritesRequest, any>(customerAddToFavorites, {
    onSuccess: (_, data) => {
      GTMService.addToWishlist(data.data.id, data.data.name);
      toast.success(t('FAVOURITE_ADD'));
      refetch();
    },
    onError: () => {
      toast.error('Error on added on favorite');
    },
  });

  const removeFavorite = useMutation<any, string, ICustomerAddToFavoritesRequest>(customerRemoveFromFavorites, {
    onSuccess: () => {
      toast.success(t('FAVOURITE_REMOVE'));
      refetch();
    },
    onError: () => {
      toast.error('Error on remove on favorite');
    },
  });

  const onEditFavorites = (data: ICustomerAddToFavoritesRequest) => {
    let changedElement = {} as ICustomerAddToFavoritesRequest;

    for (let i = 0; i < myFavorite.length; i++) {
      if (myFavorite[i].slug === data.slug) {
        changedElement = {...data};
      }
    }
    Object.keys(changedElement).length ? removeFavorite.mutateAsync(changedElement) : addFavorite.mutateAsync(data);
  };

  return {myFavorite, onEditFavorites, isLoading};
};
